import getDSDataAtPath from './utils/getDSDataAtPath';
import mergeDataSchema from './utils/mergeDataSchema';
export default class DefinitionManager {
    constructor(root) {
        this.cache = {};
        this.root = root;
    }
    /**
     * 不加工地获取 `#/definitions/xxx` 这种在 root 里指向的东西
     */
    getRawDefinitionFromRoot(ref) {
        const parts = ref.split('/').slice(1); // 去掉 #
        return getDSDataAtPath(this.root, parts);
    }
    getDefinition(ref) {
        // ref 到的地方可能会 ref 其他的东西，因此先按照最混合 --> 最原始 的顺序，准备
        const stack = [];
        while (ref) {
            if (ref in this.cache) {
                // 当前的 ref 引用目标有被缓存过，可复用缓存里的信息，并终止后续链条内容
                const cached = this.cache[ref];
                stack.push({ ref, schema: cached.schema });
                break;
            }
            // 处理循环引用的问题
            // eslint-disable-next-line no-loop-func
            if (stack.some(X => X.ref === ref)) {
                throw new Error(`Found ref loop: ${stack.map(x => x.ref).join(' -> ')} -? ${ref}`);
            }
            // 获取原始的定义
            const rawDef = this.getRawDefinitionFromRoot(ref);
            if (!rawDef)
                throw new Error(`Unknown ref ${ref}`);
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            // const { id: _unused1, ...newSchema } = rawDef as DataSchema;
            stack.push({ ref, schema: rawDef });
            ref = rawDef.$ref;
        }
        // 边界情况
        /* istanbul ignore next */
        if (!stack.length)
            return null;
        // 处理继承问题
        for (let i = stack.length - 2; i >= 0; i--) {
            const inheritFrom = stack[i + 1].schema;
            const newSchema = mergeDataSchema(inheritFrom, stack[i].schema);
            stack[i].schema = newSchema;
        }
        // 然后就可以按照顺序塞入 cache 里
        for (const { ref, schema, fromCache } of stack) {
            /* istanbul ignore next */
            if (!fromCache)
                this.cache[ref] = { ref, schema };
        }
        return stack[0].schema;
    }
}
